import { render, staticRenderFns } from "./NotifyList.vue?vue&type=template&id=adf997ee&scoped=true&"
import script from "./NotifyList.vue?vue&type=script&lang=ts&"
export * from "./NotifyList.vue?vue&type=script&lang=ts&"
import style0 from "./NotifyList.vue?vue&type=style&index=0&id=adf997ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adf997ee",
  null
  
)

export default component.exports